import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

type LogoVariant = 'full' | 'mark';

// Intrinsic aspect ratios of the two logo artworks (width / height), used to
// size the box from `height` without distorting the glyph.
const RATIO: Record<LogoVariant, number> = {
  full: 224 / 40.777,
  mark: 34.012 / 40.777,
};

/**
 * Papercast logo. `full` = icon + wordmark, `mark` = the "P" tile only. Paints
 * with `currentColor` and inherits it from context — so it's white on the dark
 * topbar and dark on light surfaces without any per-use override. Pulls its
 * artwork from the icon sprite (symbols logo-full / logo-mark), so it shares the
 * same asset pipeline as the icons rather than embedding path data here.
 */
@Component({
  selector: 'app-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      role="img"
      aria-label="Papercast"
      [attr.height]="height()"
      [attr.width]="width()"
    >
      <use [attr.href]="'#logo-' + variant()"></use>
    </svg>
  `,
  styles: `
    :host {
      display: inline-flex;
      line-height: 0;
    }
  `,
})
export class Logo {
  readonly variant = input<LogoVariant>('full');
  readonly height = input(32);

  protected readonly width = computed(
    () => Math.round(this.height() * RATIO[this.variant()] * 100) / 100,
  );
}
